"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const react_router_1 = require("react-router");
const hooks_1 = require("./hooks");
exports.DataRoutes = ({ routes, extraProps = {}, switchProps = {} }) => {
    const chyk = hooks_1.useChyk();
    return (react_1.default.createElement(react_router_1.Switch, Object.assign({}, switchProps), routes.map((route, i) => {
        const ctx = chyk.locationState;
        const keyData = (ctx.data && route.dataKey && ctx.data[route.dataKey]) || undefined;
        return (react_1.default.createElement(react_router_1.Route, { key: route.key || i, path: route.path, exact: route.exact, strict: route.strict, render: props => (route.render &&
                route.render(Object.assign(Object.assign(Object.assign(Object.assign({}, props), extraProps), keyData), { route: route, abortController: ctx.abortController }))) ||
                (route.component && (react_1.default.createElement(route.component, Object.assign({}, props, extraProps, keyData, { route: route, abortController: ctx.abortController })))) }));
    })));
};
exports.DataRoutes.displayName = "DataRoutes";
//# sourceMappingURL=routes.js.map